// Navegación INTERNA del Almacén.
//
// Antes el almacén ocupaba 8 de las 29 entradas del menú lateral: Escanear, Alta rápida, Escanear
// compra, Productos… son pantallas DE DENTRO del almacén, no secciones del programa. Ahora el menú
// tiene una sola entrada ("Almacén") y aquí se navega entre sus pantallas.
//
// B-270 · Y CADA UNA TIENE SU PROPIO PERMISO. Hasta hoy esto era todo o nada: quien tenía el módulo
// veía las nueve, así que la auxiliar que solo apunta lo que se gasta entraba igual a Proveedores y
// a los precios de compra. La lista y las claves están en services/pestanasModulo (espejo del
// catálogo del servidor); aquí solo se filtra. De fábrica no cambia nada para nadie: la pestaña la
// tiene quien tiene el módulo, y esta barra solo esconde lo que la clínica haya DENEGADO.
import { NavLink } from 'react-router-dom'
import { usePermisos } from '../hooks/usePermisos'
import { PESTANAS_ALMACEN, pestanaAbierta } from '../services/pestanasModulo'
import { marca, tDato } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

// B-2259 · Los nombres de las pestañas viven en services/pestanasModulo (el espejo del catálogo del servidor, que una
// guardia compara clave a clave): allí se quedan en castellano y aquí se apuntan para el diccionario; la barra los enseña
// con tDato (por su castellano). Una pestaña nueva que no esté aquí sale en castellano, nunca rota.
const NOMBRES_PESTANAS = [   // eslint-disable-line no-unused-vars
  marca('components.StockTabs.resumen', 'Resumen'),
  marca('components.StockTabs.escanear', 'Escanear'),
  marca('components.StockTabs.alta_rapida', 'Alta rápida'),
  marca('components.StockTabs.escanear_compra', 'Escanear compra'),
  marca('components.StockTabs.productos', 'Productos'),
  marca('components.StockTabs.proveedores', 'Proveedores'),
  marca('components.StockTabs.ubicaciones', 'Ubicaciones'),
  marca('components.StockTabs.lista_de_compra', 'Lista de compra'),
  marca('components.StockTabs.reutilizables', 'Reutilizables'),
]

export default function StockTabs() {
  // EL ENCARGADO DE UNA LISTA NO VE EL MÓDULO, SOLO SU LISTA (B-102). Entra por la puerta acotada de
  // services/accesoAcotado —que le abre la lista de la compra y nada más—, así que pintarle esta
  // barra sería ofrecerle ocho pantallas que el servidor le va a negar con un 403. Una pantalla no
  // puede prometer lo que el sistema no hace.
  const { perms } = usePermisos()
  if (perms?.stock !== true && perms?._compras_encargado === true) return null
  const tabs = PESTANAS_ALMACEN.filter((t) => pestanaAbierta(perms, t.clave))
  // Sin ninguna pestaña no se pinta una barra vacía: quien lo dice es la pantalla de dentro
  // (components/SinPestanas, montada por la puerta de ruta), con una frase que se puede accionar.
  if (!tabs.length) return null
  return (
    <nav style={{
      display: 'flex', gap: 6, overflowX: 'auto', padding: '2px 0 10px',
      borderBottom: '1px solid var(--border)', marginBottom: 14,
      // En la tablet del almacén se navega con el dedo: la barra se desliza sin cortar nada.
      WebkitOverflowScrolling: 'touch', scrollbarWidth: 'thin',
    }}>
      {tabs.map(({ ruta, label, exacta }) => (
        <NavLink key={ruta} to={ruta} end={!!exacta}
          style={({ isActive }) => ({
            flexShrink: 0, padding: '8px 14px', borderRadius: 10, fontSize: 13.5, fontWeight: isActive ? 800 : 600,
            color: isActive ? 'var(--primary)' : 'var(--text-secondary)',
            background: isActive ? 'color-mix(in srgb, var(--primary) 10%, transparent)' : 'transparent',
            textDecoration: 'none', whiteSpace: 'nowrap',
          })}>
          {tDato(label)}
        </NavLink>
      ))}
    </nav>
  )
}
